export default __webpack_public_path__ + "static/media/logo_avina.bb409923.png";